export enum TipoTrackingEnum {
  DEFAULT = '',
  CORTE = 'CORTE',
  CICLO_FACTURACION = 'CICLO_FACTURACION',
}
